import BaseReducer from "shared/types/baseReducer";
import { PaymentWrapperAction, PaymentWrapperView } from "./enum";
import { PaymentWrapperActionType, PaymentWrapperDispatchInterface, PaymentWrapperState } from "./type";

export default class Reducer extends BaseReducer<PaymentWrapperActionType> implements PaymentWrapperDispatchInterface {
  static getInitialState(): PaymentWrapperState {
    return {
      paymentWrapperView: PaymentWrapperView.NONE,
      canShowPaymentModes: true,
      canShowResendInvoicePaymentRequestAction: false,
      canShowUpdateInvoicePaymentRequestAction: false
    };
  }

  static reducer(state: PaymentWrapperState, action: PaymentWrapperActionType): PaymentWrapperState {
    switch (action.type) {
      case PaymentWrapperAction.SET_PAYMENT_WRAPPER_VIEW:
        return { ...state, paymentWrapperView: action.payload };
      case PaymentWrapperAction.SHOW_PAYMENT_MODES:
        return { ...state, canShowPaymentModes: action.payload };
      case PaymentWrapperAction.SHOW_RESEND_INVOICE_PAYMENT_REQUEST_ACTION:
        return {
          ...state,
          canShowResendInvoicePaymentRequestAction: action.payload,
          canShowUpdateInvoicePaymentRequestAction: !action.payload
        };
      case PaymentWrapperAction.SHOW_UPDATE_INVOICE_PAYMENT_REQUEST_ACTION:
        return {
          ...state,
          canShowUpdateInvoicePaymentRequestAction: action.payload,
          canShowResendInvoicePaymentRequestAction: !action.payload
        };
      default:
        return state;
    }
  }

  public setPaymentWrapperView(payload: PaymentWrapperView) {
    return this.dispatch({ type: PaymentWrapperAction.SET_PAYMENT_WRAPPER_VIEW, payload });
  }

  public setShowPaymentModes(payload: boolean) {
    return this.dispatch({ type: PaymentWrapperAction.SHOW_PAYMENT_MODES, payload });
  }

  public setShowResendInvoicePaymentRequestAction(payload: boolean) {
    return this.dispatch({ type: PaymentWrapperAction.SHOW_RESEND_INVOICE_PAYMENT_REQUEST_ACTION, payload });
  }

  public setShowUpdateInvoicePaymentRequestAction(payload: boolean) {
    return this.dispatch({ type: PaymentWrapperAction.SHOW_UPDATE_INVOICE_PAYMENT_REQUEST_ACTION, payload });
  }
}
